import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms">
      <Link to="/" className="return-home-button">
        Return Home
      </Link>
      
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <h1>Terms and Conditions</h1>
          <p>Currently being finalized</p>
        </div>
      </section>

      {/* Content Section */}
      <div className="terms-content">
        <div className="pending-notice">
          <h2>Terms and Conditions - Currently Pending</h2>
          <p>
            Our comprehensive Terms and Conditions are currently being finalized and will be 
            available soon. We are working to ensure they accurately reflect our services and 
            provide clear guidelines for all users.
          </p>
          
          <p>
            In the meantime, if you have any questions about our services, policies, or 
            general terms of use, please don't hesitate to contact us directly.
          </p>

          <section>
            <h3>Contact Us</h3>
            <p>
              For questions or concerns, please reach out to us at:
            </p>
            <p>
              <strong>Flygon LC</strong><br />
              Email: info@flygonlc.com
            </p>
          </section>

          <p className="check-back">
            <strong>Please check back soon for our complete Terms and Conditions.</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
